import React, { useState } from 'react';
import { Mail, Send, CheckCircle2 } from 'lucide-react';
import { submitChatLead } from '../../lib/charlieChat';
import { trackEvent } from '../../lib/analytics';
import { logError } from '../../lib/logger';

export const ChatLeadCard = ({ sessionId, question, pagePath, onRequestDemo, onRequestQuote }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState('idle');

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('sending');
    try {
      await submitChatLead({ session_id: sessionId, email, name: name || null, question, page_path: pagePath });
      trackEvent('chat_lead_submit');
      setStatus('sent');
    } catch (err) {
      logError('charlie lead failed', err);
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="ml-10 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800 flex items-start gap-2" data-testid="charlie-lead-success">
        <CheckCircle2 className="h-4 w-4 mt-0.5 flex-shrink-0" />
        <span>Got it — your question is on its way to the ctrl.aero team. They'll reply to <strong>{email}</strong>.</span>
      </div>
    );
  }

  return (
    <div className="ml-10 rounded-2xl border border-orange-200 bg-gradient-to-br from-orange-50 to-white p-4 text-sm shadow-sm" data-testid="charlie-lead-card">
      <p className="font-semibold text-[#1e2d3b] flex items-center gap-2"><Mail className="h-4 w-4 text-orange-500" /> Want a human to answer that?</p>
      <p className="mt-1 text-xs text-slate-600">Leave your email and I'll pass your question straight to the ctrl.aero team.</p>
      <form onSubmit={submit} className="mt-3 space-y-2">
        <input
          type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name (optional)"
          className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
          data-testid="charlie-lead-name"
        />
        <div className="flex gap-2">
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com"
            className="min-w-0 flex-1 rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
            data-testid="charlie-lead-email"
          />
          <button
            type="submit" disabled={status === 'sending'}
            className="inline-flex items-center gap-1.5 rounded-lg bg-orange-500 px-3 py-2 text-xs font-semibold text-white hover:bg-orange-600 disabled:opacity-60 transition-colors"
            data-testid="charlie-lead-submit"
          >
            <Send className="h-3.5 w-3.5" /> {status === 'sending' ? 'Sending…' : 'Send'}
          </button>
        </div>
        {status === 'error' && <p className="text-xs text-red-600" data-testid="charlie-lead-error">Couldn't send right now — please try again.</p>}
      </form>
      {(onRequestDemo || onRequestQuote) && (
        <div className="mt-3 flex flex-wrap gap-2 border-t border-orange-100 pt-3">
          {onRequestDemo && (
            <button type="button" onClick={() => onRequestDemo({ resource: 'charlie-echo' })} className="rounded-full border border-blue-200 bg-white px-3 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-50 transition-colors" data-testid="charlie-lead-demo">Request Demo</button>
          )}
          {onRequestQuote && (
            <button type="button" onClick={() => onRequestQuote({ resource: 'charlie-echo' })} className="rounded-full border border-orange-200 bg-white px-3 py-1 text-xs font-semibold text-orange-700 hover:bg-orange-50 transition-colors" data-testid="charlie-lead-quote">Request Quote</button>
          )}
        </div>
      )}
    </div>
  );
};
